(() => {
  const shortClawLabel = (name) => {
    const title = String(name || '').toLowerCase();
    if (title.includes('mega')) return 'Mega';
    if (title.includes('colossal')) return 'Colossal';
    if (title.includes('jumbo')) return 'Jumbo';
    if (title.includes('large')) return 'Large';
    if (title.includes('medium')) return 'Medium';
    return String(name || '');
  };

  const ensureClawStores = () => {
    if (!Alpine.store('xClawStickyLbPrices')) {
      Alpine.store('xClawStickyLbPrices', {
        enabled: false,
        showCompetitor: true,
        lbPrice: '',
        competitorsPrice: '',
      });
    }

    if (!Alpine.store('xClawStickyControls')) {
      Alpine.store('xClawStickyControls', {
        ready: false,
        clawSizes: [],
        dinnerSizes: [],
        selectedClawIndex: 0,
        selectedDinnerIndex: 0,
        selectedClawLabel: '',
        selectedDinnerLabel: '',
        _api: null,
        _updateSummary() {
          const size = this.clawSizes[this.selectedClawIndex];
          this.selectedClawLabel = size?.label || size?.name || '';
          const dinner = this.dinnerSizes[this.selectedDinnerIndex];
          if (dinner === undefined || dinner === null || dinner === '') {
            this.selectedDinnerLabel = '';
            return;
          }
          const raw = String(dinner).trim();
          this.selectedDinnerLabel = /^dinner\s+for\s+/i.test(raw)
            ? raw.replace(/^d/, 'D')
            : `Dinner for ${raw}`;
        },
        bind(api) {
          this._api = api;
          this.ready = true;
          this.syncFrom(api);
        },
        syncFrom(api) {
          if (!api) return;
          this.clawSizes = (api.clawSizes || []).map((size) => ({
            name: size.name,
            label: shortClawLabel(size.name),
          }));
          this.dinnerSizes = (api.dinnerSizes || []).map((dinner) => String(dinner));
          this.selectedClawIndex = Number.isInteger(api.selectedClawIndex) ? api.selectedClawIndex : 0;
          this.selectedDinnerIndex = Number.isInteger(api.selectedDinnerIndex) ? api.selectedDinnerIndex : 0;
          this._updateSummary();
        },
        selectClaw(index) {
          const nextIndex = parseInt(index, 10);
          if (Number.isNaN(nextIndex) || !this._api) return;
          this.selectedClawIndex = nextIndex;
          this._updateSummary();
          this._api.selectClawIndex(nextIndex);
        },
        selectDinner(index) {
          const nextIndex = parseInt(index, 10);
          if (Number.isNaN(nextIndex) || !this._api) return;
          this.selectedDinnerIndex = nextIndex;
          this._updateSummary();
          this._api.selectDinnerIndex(nextIndex);
        },
      });
    }
  };

  const registerInteractiveClawSelector = () => {
    ensureClawStores();

    Alpine.data('xInteractiveClawSelector', () => ({
      mode: 'single',
      clawSizes: [],
      dinnerSizes: [],
      variants: [],
      sizeWeights: {},
      selectedClawSize: '',
      selectedDinner: '',
      selectedDinnerIndex: 0,
      selectedClawIndex: -1,
      hoveredClawIndex: null,
      hoveredDinner: null,
      hoveredDinnerIndex: null,
      sectionId: '',
      productId: '',
      productUrl: '',
      isProductPage: false,
      moneyFormat: '',
      dataView: 'claw-selector-data',
      cachedHtml: {},
      cachedSiblingData: {},
      siblingFetchPromises: {},
      loading: false,
      hasIncludedProducts: false,
      showPricing: true,
      showCompetitorPrice: true,
      defaultServingSizeLbs: '',

      init() {
        const configEl = this.$root.querySelector('[data-claw-selector-config]');
        if (!configEl) return;

        let config;
        try {
          config = JSON.parse(configEl.textContent.trim());
        } catch (error) {
          console.error('Interactive claw selector: invalid config JSON', error);
          return;
        }

        this.mode = config.mode || 'single';
        this.dataView = config.dataView || 'claw-selector-data';
        this.clawSizes = this._normalizeClawSizes(config.clawSizes || []);
        this.dinnerSizes = (config.dinnerSizes || []).map((d) => String(d));
        this.variants = Array.isArray(config.variants) ? [...config.variants] : [];
        this.sizeWeights = { ...(config.sizeWeights || {}) };
        this.hasIncludedProducts = Boolean(config.hasIncludedProducts);
        this.showPricing = config.showPricing !== false;
        this.showCompetitorPrice = config.showCompetitorPrice !== false;
        this.defaultServingSizeLbs = config.defaultServingSizeLbs || '';
        this.sectionId = config.sectionId;
        this.productId = config.productId || '';
        this.productUrl = config.productUrl;
        this.isProductPage = config.isProductPage;
        this.moneyFormat = config.moneyFormat;

        this.selectedClawSize = config.initialClawSize || this.clawSizes[0]?.name || '';
        if (!this.selectedClawSize && this.clawSizes.length) {
          const current = this.clawSizes.find((s) => s.isCurrent);
          this.selectedClawSize = current?.name || this.clawSizes[0].name;
        }

        this.selectedDinner = '2';
        if (this.dinnerSizes.length && !this.dinnerSizes.includes(this.selectedDinner)) {
          this.selectedDinner = String(this.dinnerSizes[0] || '2');
        }
        this.selectedDinnerIndex = this.dinnerSizes.indexOf(this.selectedDinner);
        if (this.selectedDinnerIndex < 0) this.selectedDinnerIndex = 0;
        this.selectedDinner = String(this.dinnerSizes[this.selectedDinnerIndex] || this.selectedDinner);

        this.selectedClawIndex = this.clawSizes.findIndex((s) => s.name === this.selectedClawSize);
        if (this.selectedClawIndex < 0) this.selectedClawIndex = 0;
        this.selectedClawSize = this.clawSizes[this.selectedClawIndex]?.name || this.selectedClawSize;

        if (config.initialVariant) {
          this._updateSelectedVariantScript({ raw: config.initialVariant, ...config.initialVariant });
        }

        Alpine.store('xClawStickyControls').bind(this);
        this.$watch('selectedClawIndex', () => {
          this._publishStickyLbPrices();
          this._syncStickyControls();
          this._syncIncludedQty();
        });
        this.$watch('selectedDinnerIndex', () => {
          this._publishStickyLbPrices();
          this._syncStickyControls();
          this._syncIncludedQty();
        });
        this._publishStickyLbPrices();
        this._syncStickyControls();

        this._bootstrapCombinedListing().then(() => {
          const committed = this.getCommittedVariant();
          if (committed) {
            this.productUrl = committed.productUrl || this._clawSizeMeta(this.selectedClawSize)?.productUrl || this.productUrl;
            this._applyActiveSiblingState(this.productUrl);
            this._updateProductForms(committed.id);
            this._enableAtcButton(committed);
            this.syncVariant(committed.id, false, { skipSiblingNav: true });
          } else if (this.mode === 'combined_listing') {
            const firstWithUrl = this.clawSizes.find((s) => s.productUrl);
            if (firstWithUrl) {
              this.selectClawIndex(this.clawSizes.indexOf(firstWithUrl), { replaceHistory: true });
            }
          }
          this._syncStickyControls();
        });
      },

      _syncStickyControls() {
        const store = Alpine.store('xClawStickyControls');
        if (store) store.syncFrom(this);
      },

      _normalizeClawSizes(sizes) {
        return sizes.map((size) => {
          if (size && typeof size === 'object') {
            return {
              name: String(size.name || ''),
              productUrl: size.productUrl || '',
              isCurrent: Boolean(size.isCurrent),
            };
          }
          return {
            name: String(size || ''),
            productUrl: '',
            isCurrent: false,
          };
        }).filter((size) => size.name);
      },

      _clawSizeMeta(name) {
        return this.clawSizes.find((s) => s.name === name);
      },

      _siblingDataUrl(productUrl) {
        if (!productUrl) return '';
        const url = new URL(productUrl, window.location.origin);
        url.searchParams.set('view', this.dataView);
        return url.pathname + url.search;
      },

      async _fetchSiblingData(productUrl) {
        if (!productUrl) return null;
        if (this.cachedSiblingData[productUrl]) return this.cachedSiblingData[productUrl];
        if (this.siblingFetchPromises[productUrl]) return this.siblingFetchPromises[productUrl];

        const requestUrl = this._siblingDataUrl(productUrl);
        this.siblingFetchPromises[productUrl] = fetch(requestUrl)
          .then((response) => {
            if (!response.ok) throw new Error(`Sibling data failed: ${response.status}`);
            return response.text();
          })
          .then((text) => {
            const data = JSON.parse(text.trim());
            this.cachedSiblingData[productUrl] = data;
            this._mergeSiblingConfig(data, productUrl);
            return data;
          })
          .catch((error) => {
            console.error('Interactive claw selector: sibling hydrate failed', productUrl, error);
            return null;
          })
          .finally(() => {
            delete this.siblingFetchPromises[productUrl];
          });

        return this.siblingFetchPromises[productUrl];
      },

      _mergeSiblingConfig(data, productUrl) {
        if (!data) return;

        const incomingVariants = Array.isArray(data.variants) ? data.variants : [];
        incomingVariants.forEach((variant) => {
          const normalized = {
            ...variant,
            productUrl: variant.productUrl || productUrl,
            dinnerFor: String(variant.dinnerFor),
          };
          const existingIndex = this.variants.findIndex(
            (v) =>
              v.clawSize === normalized.clawSize &&
              String(v.dinnerFor) === String(normalized.dinnerFor)
          );
          if (existingIndex >= 0) {
            this.variants.splice(existingIndex, 1, normalized);
          } else {
            this.variants.push(normalized);
          }
        });

        Object.entries(data.sizeWeights || {}).forEach(([size, weight]) => {
          if (weight !== null && weight !== undefined && weight !== '') {
            this.sizeWeights[size] = weight;
          }
        });

        if (data.productId && this._sameProductUrl(productUrl, this.productUrl)) {
          this.productId = data.productId;
        }

        if (data.defaultServingSizeLbs && !this.defaultServingSizeLbs) {
          this.defaultServingSizeLbs = data.defaultServingSizeLbs;
        }

        // Prefer product-level serving size from the active sibling when present.
        if (data.defaultServingSizeLbs && productUrl === this.productUrl) {
          this.defaultServingSizeLbs = data.defaultServingSizeLbs;
        }

        this._syncStickyControls();
      },

      async _bootstrapCombinedListing() {
        const urls = [
          ...new Set(
            this.clawSizes
              .map((size) => size.productUrl)
              .filter((url) => url && url !== this.productUrl)
          ),
        ];

        // Always cache current product config if present.
        if (this.productUrl) {
          this.cachedSiblingData[this.productUrl] = {
            variants: this.variants.filter((v) => !v.productUrl || v.productUrl === this.productUrl),
            sizeWeights: this.sizeWeights,
            hasIncludedProducts: this.hasIncludedProducts,
            productId: this.productId,
            defaultServingSizeLbs: this.defaultServingSizeLbs,
          };
        }

        if (!urls.length && this.mode !== 'combined_listing') return;

        // If current product has no dinner variants (parent shell), hydrate its current/first sibling first.
        const needsCurrentHydration = !this.variants.some(
          (v) => v.clawSize === this.selectedClawSize && String(v.dinnerFor) === String(this.selectedDinner)
        );
        if (needsCurrentHydration) {
          const selectedMeta = this._clawSizeMeta(this.selectedClawSize);
          const hydrateUrl = selectedMeta?.productUrl || this.clawSizes[0]?.productUrl;
          if (hydrateUrl) {
            await this._fetchSiblingData(hydrateUrl);
            this.productUrl = hydrateUrl;
          }
        }

        await Promise.all(urls.map((url) => this._fetchSiblingData(url)));
      },

      _publishStickyLbPrices() {
        const store = Alpine.store('xClawStickyLbPrices');
        if (!store) return;
        const variant = this.getCommittedVariant();
        store.enabled = this.showPricing;
        store.showCompetitor = this.showCompetitorPrice;
        store.lbPrice = variant?.lbPrice || '';
        store.competitorsPrice = variant?.competitorsPrice || '';
      },

      get displayClawIndex() {
        if (this.hoveredClawIndex !== null) return this.hoveredClawIndex;
        return this.selectedClawIndex;
      },

      get previewClawIndex() {
        return this.displayClawIndex;
      },

      get displayDinner() {
        if (this.hoveredDinnerIndex !== null) {
          return String(this.dinnerSizes[this.hoveredDinnerIndex] || '');
        }
        return this.selectedDinner;
      },

      get displayClawSize() {
        return this.clawSizes[this.displayClawIndex]?.name || this.selectedClawSize;
      },

      get displayVariant() {
        return this.findVariant(this.displayClawSize, this.displayDinner);
      },

      get displayServingSizeLbs() {
        const fromVariant = this.displayVariant?.servingSizeLbs;
        if (fromVariant !== null && fromVariant !== undefined && fromVariant !== '') {
          return fromVariant;
        }
        return this.defaultServingSizeLbs || '';
      },

      get includedQty() {
        const dinner = parseInt(this.displayDinner, 10);
        if (!Number.isFinite(dinner) || dinner <= 0) return 1;
        return Math.max(1, Math.floor(dinner / 2));
      },

      get hasIncludedItems() {
        return this.hasIncludedProducts;
      },

      get servingPreviewText() {
        const text = this.buildServingText(this.previewClawIndex);
        if (text) return text;
        const clawSize = this.clawSizes[this.previewClawIndex]?.name;
        return clawSize ? `— ${clawSize} Claws Per Person` : '—';
      },

      get selectedLineStyle() {
        const height = this.getClawHeightPx(this.selectedClawIndex);
        if (!height) return { display: 'none' };
        return { bottom: `${height}px` };
      },

      get hoverLineStyle() {
        if (this.hoveredClawIndex === null || this.hoveredClawIndex === this.selectedClawIndex) {
          return { display: 'none' };
        }
        const height = this.getClawHeightPx(this.hoveredClawIndex);
        if (!height) return { display: 'none' };
        return { bottom: `${height}px` };
      },

      get isHoverPreview() {
        return this.hoveredClawIndex !== null && this.hoveredClawIndex !== this.selectedClawIndex;
      },

      getCommittedVariant() {
        return this.findVariant(this.selectedClawSize, this.selectedDinner);
      },

      findVariant(clawSize, dinner) {
        const dinnerStr = String(dinner);
        return this.variants.find(
          (v) => v.clawSize === clawSize && String(v.dinnerFor) === dinnerStr
        );
      },

      _enableAtcButton(variant) {
        document
          .querySelectorAll(
            `#x-atc-button-${this.sectionId}, #product-form-${this.sectionId} .add_to_cart_button, #product-form-sticky-${this.sectionId} .add_to_cart_button`
          )
          .forEach((btn) => {
            if (variant?.available) {
              btn.removeAttribute('disabled');
            } else {
              btn.setAttribute('disabled', 'disabled');
            }
          });
      },

      getSizeWeight(index) {
        const clawSize = this.clawSizes[index]?.name;
        return clawSize ? this.sizeWeights[clawSize] || '' : '';
      },

      buildServingText(index) {
        const clawSize = this.clawSizes[index]?.name;
        if (!clawSize) return '';
        const variant =
          this.findVariant(clawSize, this.displayDinner) ||
          this.findVariant(clawSize, this.selectedDinner) ||
          this.variants.find((v) => v.clawSize === clawSize);
        if (!variant || variant.clawsPerPerson === null || variant.clawsPerPerson === undefined || variant.clawsPerPerson === '') {
          return '';
        }
        return `${variant.clawsPerPerson} ${clawSize} Claws Per Person`;
      },

      getClawHeightPx(index) {
        if (index < 0) return 0;
        return 64 + index * 16;
      },

      formatServingSize(val) {
        if (val === null || val === undefined || val === '') return '';
        const text = String(val).trim();
        if (/per person/i.test(text)) return text;
        return `${text} Lbs Per Person`;
      },

      formatLbPrice(val) {
        if (val === null || val === undefined || val === '') return '';
        const s = String(val).trim();
        return s.startsWith('$') ? s : `$${s}`;
      },

      hoverClawIndex(index) {
        this.hoveredClawIndex = index;
        const size = this.clawSizes[index];
        if (!size) return;
        if (size.productUrl && !this.findVariant(size.name, this.selectedDinner)) {
          this._fetchSiblingData(size.productUrl);
        }
        const preview = this.findVariant(size.name, this.selectedDinner);
        if (preview) this._goToVariantMedia(preview);
      },

      clearHover() {
        this.hoveredClawIndex = null;
        const committed = this.getCommittedVariant();
        if (committed) this._goToVariantMedia(committed);
      },

      async selectClawIndex(index, options = {}) {
        const size = this.clawSizes[index];
        if (!size) return;

        const previousProductUrl = this.productUrl;
        this.selectedClawIndex = index;
        this.selectedClawSize = size.name;
        this.hoveredClawIndex = null;

        if (size.productUrl) {
          await this._fetchSiblingData(size.productUrl);
          this.productUrl = size.productUrl;
          this._applyActiveSiblingState(size.productUrl);
        }

        const variant = this.getCommittedVariant();
        if (variant) {
          const nextProductUrl = size.productUrl || variant.productUrl;
          this.syncVariant(variant.id, true, {
            forceProductUrl: nextProductUrl,
            replaceHistory: options.replaceHistory !== false,
            productSwap: Boolean(nextProductUrl && !this._sameProductUrl(nextProductUrl, previousProductUrl)),
          });
        }
      },

      selectDinnerIndex(index) {
        const dinner = this.dinnerSizes[index];
        if (dinner === undefined) return;
        this.selectedDinnerIndex = index;
        this.selectedDinner = String(dinner);
        this.hoveredDinnerIndex = null;
        this.hoveredDinner = null;
        const variant = this.getCommittedVariant();
        if (variant) this.syncVariant(variant.id, true);
      },

      hoverDinnerIndex(index) {
        const dinner = this.dinnerSizes[index];
        if (dinner === undefined) return;
        this.hoveredDinnerIndex = index;
        this.hoveredDinner = String(dinner);
      },

      clearDinnerHover() {
        this.hoveredDinnerIndex = null;
        this.hoveredDinner = null;
      },

      syncVariant(variantId, updateUrl, options = {}) {
        if (!variantId) return;

        const variant = this.variants.find((v) => v.id === variantId);
        if (!variant) return;

        const targetProductUrl = options.forceProductUrl || variant.productUrl || this.productUrl;
        if (targetProductUrl) this.productUrl = targetProductUrl;

        this._updateProductForms(variantId);
        this._goToVariantMedia(variant);
        this._updateSelectedVariantScript(variant);

        if (updateUrl && this.isProductPage && options.replaceHistory !== false) {
          const nextUrl = `${this.productUrl}?variant=${variantId}`;
          window.history.replaceState({}, '', nextUrl);
        }

        if (options.skipSiblingNav) {
          this._publishStickyLbPrices();
          return;
        }

        const link = options.productSwap
          ? this._productPageFetchUrl(variantId)
          : this._sectionFetchUrl(variantId);

        if (this.cachedHtml[link]) {
          this._applyFetchedHtml(this.cachedHtml[link], variant, options.productSwap);
          return;
        }

        this.loading = true;
        Alpine.store('xHelper')?.cancelRequest?.('eurus:claw_selector_request');
        const controller = new AbortController();
        Alpine.store('xHelper')?.requestControllers?.set('eurus:claw_selector_request', controller);

        fetch(link, { signal: controller.signal })
          .then((response) => response.text())
          .then((responseText) => {
            const html = new DOMParser().parseFromString(responseText, 'text/html');
            this.cachedHtml[link] = html;
            this._applyFetchedHtml(html, variant, options.productSwap);
          })
          .catch((err) => {
            if (err.name !== 'AbortError') console.error(err);
          })
          .finally(() => {
            this.loading = false;
          });
      },

      _updateProductForms(variantId) {
        document
          .querySelectorAll(
            `#product-form-${this.sectionId}, #product-form-installment-${this.sectionId}, #product-form-sticky-${this.sectionId}`
          )
          .forEach((form) => {
            const input = form.querySelector('input[name="id"]');
            if (input) {
              input.value = variantId;
              input.dispatchEvent(new Event('change', { bubbles: true }));
            }
          });
      },

      _updateSelectedVariantScript(variant) {
        const el = this.$refs.variantData;
        if (el) el.textContent = JSON.stringify(variant.raw || variant);
      },

      _mediaRoot(doc) {
        const root = doc || document;
        const splideEl = root.getElementById(`x-product-${this.sectionId}`);
        if (splideEl) {
          const container =
            splideEl.closest('.product-media-container') ||
            splideEl.closest('.product-media');
          if (container) return container;
        }
        return (
          root.querySelector(`#MediaGallery-${this.sectionId}`) ||
          root.querySelector(`.product-images-${this.sectionId}`) ||
          null
        );
      },

      _goToVariantMedia(variant) {
        if (!variant?.featuredMediaId) return;

        const slideEls = document.getElementsByClassName(
          `${variant.featuredMediaId}-${this.sectionId}`
        );
        if (!slideEls.length) return;

        const index = parseInt(slideEls[0].getAttribute('index'), 10);
        const splideEl = document.getElementById(`x-product-${this.sectionId}`);
        if (splideEl?.splide && !Number.isNaN(index)) {
          splideEl.splide.go(index);
        }

        const activeEl = document.getElementById(
          `postion-image-${this.sectionId}-${variant.featuredMediaId}`
        );
        const stackedEl = document.getElementById(`stacked-${this.sectionId}`);
        if (stackedEl && activeEl) stackedEl.prepend(activeEl);
      },

      _updateVariantMetafieldBlocks(html) {
        ['.variant-rich-text', '.variant-icons-text'].forEach((selector) => {
          const destinations = document.querySelectorAll(`${selector}-${this.sectionId}`);
          const sources = html.querySelectorAll(`${selector}-${this.sectionId}`);
          if (!destinations.length || !sources.length) return;

          destinations.forEach((dest, index) => {
            const source = sources[index];
            if (!source) return;
            dest.innerHTML = source.innerHTML;
            dest.classList.toggle('hidden', source.classList.contains('hidden'));
          });
        });
      },

      // Section HTML keeps sticky ATC inside <template x-teleport>, which querySelector on the
      // document root cannot see. Search teleport template content as a fallback.
      _queryInDoc(root, selector) {
        if (!root || !selector) return null;
        const direct = root.querySelector?.(selector);
        if (direct) return direct;

        const templates = root.querySelectorAll?.('template[x-teleport], template') || [];
        for (const tpl of templates) {
          const found = tpl.content?.querySelector?.(selector);
          if (found) return found;
        }
        return null;
      },

      _updateStickyButtonPrice(variant) {
        const stickyForm = document.getElementById(`product-form-sticky-${this.sectionId}`);
        const priceEl = stickyForm?.querySelector('.sticky-atc-button-price');
        if (!priceEl || !variant) return;

        if (variant.priceFormatted) {
          priceEl.innerHTML = variant.priceFormatted;
          return;
        }
        if (variant.price !== null && variant.price !== undefined && variant.price !== '') {
          const cents = Number(variant.price);
          if (!Number.isNaN(cents)) {
            priceEl.textContent = Shopify?.formatMoney
              ? Shopify.formatMoney(cents)
              : `$${(cents / 100).toFixed(2)}`;
          }
        }
      },

      _sameProductUrl(a, b) {
        if (!a || !b) return a === b;
        try {
          return new URL(a, window.location.origin).pathname === new URL(b, window.location.origin).pathname;
        } catch (error) {
          return String(a) === String(b);
        }
      },

      _sectionFetchUrl(variantId) {
        const url = new URL(this.productUrl, window.location.origin);
        url.searchParams.set('section_id', this.sectionId);
        if (variantId) url.searchParams.set('variant', String(variantId));
        return url.pathname + url.search;
      },

      _productPageFetchUrl(variantId) {
        const url = new URL(this.productUrl, window.location.origin);
        if (variantId) url.searchParams.set('variant', String(variantId));
        return url.pathname + url.search;
      },

      _applyActiveSiblingState(productUrl) {
        const data = this.cachedSiblingData[productUrl];
        if (!data) return;
        this.hasIncludedProducts = Boolean(data.hasIncludedProducts);
        if (data.defaultServingSizeLbs) this.defaultServingSizeLbs = data.defaultServingSizeLbs;
        if (data.productId) this.productId = data.productId;
      },

      _applyFetchedHtml(html, variant, productSwap) {
        if (productSwap) this._applyProductSwap(html);
        this._applySectionUpdate(html, variant);
      },

      _productInfoRoot(doc) {
        const root = doc || document;
        if (this.sectionId) {
          const byId = root.getElementById(`ProductInfo-${this.sectionId}`);
          if (byId) return byId;
          const mainColumn = root.querySelector(`.main-product-${this.sectionId} .product-content-container`);
          if (mainColumn) return mainColumn;
        }
        return root.querySelector('.main-product .product-content-container') || root;
      },

      _copyInnerHtml(destination, source) {
        if (!destination || !source) return false;
        destination.innerHTML = source.innerHTML;
        source.classList.forEach((cls) => {
          if (!destination.classList.contains(cls)) destination.classList.add(cls);
        });
        destination.classList.toggle('hidden', source.classList.contains('hidden'));
        return true;
      },

      _syncIncludedQty() {
        const qty = this.includedQty;
        this.$root
          ?.querySelectorAll('[data-included-qty], [x-text="includedQty"]')
          .forEach((el) => {
            el.textContent = qty;
          });
      },

      _applyProductSwap(html) {
        if (!html) return;

        const srcTitle = html.querySelector('head title');
        if (srcTitle) document.title = srcTitle.textContent;

        const canonical = document.querySelector('link[rel="canonical"]');
        const srcCanonical = html.querySelector('link[rel="canonical"]');
        if (canonical && srcCanonical?.href) canonical.href = srcCanonical.href;

        const destTemplate = document.querySelector(`[id^="x-product-template-"][id$="-${this.sectionId}"]`);
        const srcTemplate = html.querySelector(`[id^="x-product-template-"][id$="-${this.sectionId}"]`);
        if (destTemplate && srcTemplate) destTemplate.id = srcTemplate.id;
        if (srcTemplate?.id) {
          const prefix = 'x-product-template-';
          const suffix = `-${this.sectionId}`;
          if (srcTemplate.id.startsWith(prefix) && srcTemplate.id.endsWith(suffix)) {
            this.productId = srcTemplate.id.slice(prefix.length, srcTemplate.id.length - suffix.length);
          }
        }

        const destContent = this._productInfoRoot(document);
        const srcContent = this._productInfoRoot(html);

        const destHeading = destContent.querySelector('.x-block-product-title .product-title, .product-title');
        const srcHeading = srcContent.querySelector('.x-block-product-title .product-title, .product-title');
        if (destHeading && srcHeading) destHeading.textContent = srcHeading.textContent;

        const destReview = destContent.querySelector('.x-review-product');
        const srcReview = srcContent.querySelector('.x-review-product');
        this._copyInnerHtml(destReview, srcReview);

        const destText =
          destContent.querySelector('[data-product-swap="short-description"]') ||
          destContent.querySelector('[class*="x-block-text-text_"]') ||
          destContent.querySelector('.x-block-text');
        const srcText =
          srcContent.querySelector('[data-product-swap="short-description"]') ||
          srcContent.querySelector('[class*="x-block-text-text_"]') ||
          srcContent.querySelector('.x-block-text');
        if (destText && srcText) {
          this._copyInnerHtml(destText, srcText);
          destText.classList.remove('hidden');
        }

        destContent.querySelectorAll('[data-product-swap="collapsible"], [class*="x-block-collapsible-tab-"]').forEach((destBlock) => {
          const key = [...destBlock.classList].find((cls) => cls.startsWith('x-block-collapsible-tab-'));
          if (!key) return;
          const srcBlock = srcContent.querySelector(`.${CSS.escape(key)}`);
          const destHtml = destBlock.querySelector('.collapsible-tab-html');
          const srcHtml = srcBlock?.querySelector('.collapsible-tab-html');
          if (destHtml && srcHtml) {
            destHtml.innerHTML = srcHtml.innerHTML;
            destBlock.classList.remove('hidden');
          }
        });

        const destCrumbs = document.getElementById(`breadcrumbs--${this.sectionId}`);
        const srcCrumbs = html.getElementById(`breadcrumbs--${this.sectionId}`);
        if (destCrumbs && srcCrumbs) destCrumbs.innerHTML = srcCrumbs.innerHTML;

        this._swapComplementary(html);
        this._swapIncludedList(html);
        this._swapJsonLd(html);
        this._swapReviewsSection(html);
        requestAnimationFrame(() => this._refreshYotpo());

        if (this.productId && Alpine.store('xProductRecently')?.setProduct) {
          Alpine.store('xProductRecently').setProduct(String(this.productId));
        }
      },

      _swapComplementary(html) {
        const dest = document.querySelector('.x-block-product-complementary');
        const src = html.querySelector('.x-block-product-complementary');
        if (!dest) return;

        if (!src) {
          dest.innerHTML = '';
          dest.classList.add('hidden');
          return;
        }

        const clone = src.cloneNode(false);
        clone.classList.remove('hidden');
        Array.from(clone.attributes).forEach((attr) => {
          if (attr.name.startsWith('x-intersect')) clone.removeAttribute(attr.name);
        });
        dest.replaceWith(clone);

        const loadAttr =
          src.getAttribute('x-intersect.once.margin.200px') ||
          src.getAttribute('x-intersect.once') ||
          '';
        const match = loadAttr.match(/load\(\$el,\s*'([^']+)'/);
        const recUrl = match?.[1];

        const finish = (inner) => {
          clone.innerHTML = inner;
          if (window.Alpine?.initTree) Alpine.initTree(clone);
        };

        if (recUrl) {
          fetch(recUrl)
            .then((response) => response.text())
            .then((text) => {
              const wrap = document.createElement('div');
              wrap.innerHTML = text;
              const recommendations = wrap.querySelector('.product-recommendations');
              finish(recommendations?.innerHTML?.trim() ? recommendations.innerHTML : src.innerHTML);
            })
            .catch((error) => {
              console.error('Interactive claw selector: complementary swap failed', error);
              finish(src.innerHTML);
            });
          return;
        }

        finish(src.innerHTML);
      },

      _swapIncludedList(html) {
        const dest = this.$root?.querySelector('.interactive-claw-selector__included-list');
        const src = html.querySelector('.interactive-claw-selector__included-list');
        if (!dest || !src) return;

        dest.innerHTML = src.innerHTML;
        dest.querySelectorAll('[x-text="includedQty"]').forEach((el) => {
          el.removeAttribute('x-text');
          el.setAttribute('data-included-qty', '');
        });
        this._syncIncludedQty();
      },

      _swapJsonLd(html) {
        const dests = document.querySelectorAll('.main-product script[type="application/ld+json"]');
        const srcs = html.querySelectorAll('.main-product script[type="application/ld+json"]');
        dests.forEach((dest, index) => {
          if (srcs[index]) dest.textContent = srcs[index].textContent;
        });
      },

      _swapReviewsSection(html) {
        const dest =
          document.querySelector('.shopify-section:has(.yotpo-widget-instance)') ||
          document.querySelector('.shopify-section:has([data-yotpo-product-id])') ||
          document.querySelector('.shopify-section:has(.yotpo)') ||
          document.querySelector('#MainContent .shopify-section:has([class*="yotpo"])');
        if (!dest) return;

        const src = (dest.id && html.getElementById(dest.id)) ||
          html.querySelector('.shopify-section:has(.yotpo-widget-instance)') ||
          html.querySelector('.shopify-section:has([data-yotpo-product-id])') ||
          html.querySelector('.shopify-section:has(.yotpo)');
        if (!src) return;

        dest.innerHTML = src.innerHTML;
      },

      _refreshYotpo() {
        try {
          if (window.yotpoWidgetsContainer?.initWidgets) {
            window.yotpoWidgetsContainer.initWidgets();
            return;
          }
          if (typeof window.yotpo?.initWidgets === 'function') {
            window.yotpo.initWidgets();
            return;
          }
          if (typeof window.yotpo?.refreshWidgets === 'function') {
            window.yotpo.refreshWidgets();
          }
        } catch (error) {
          console.error('Interactive claw selector: Yotpo refresh failed', error);
        }
      },

      _applySectionUpdate(html, variant) {
        const priceDest = document.getElementById(`price-${this.sectionId}`);
        const priceSrc = html.getElementById(`price-${this.sectionId}`);
        if (priceSrc && priceDest) priceDest.innerHTML = priceSrc.innerHTML;

        document
          .querySelectorAll(
            `#product-form-${this.sectionId}, #product-form-installment-${this.sectionId}, #product-form-sticky-${this.sectionId}`
          )
          .forEach((productForm) => {
            const formId = productForm.getAttribute('id');
            const atcSource = this._queryInDoc(html, `#${formId} .add_to_cart_button`);
            const atcDestination = productForm.querySelector('.add_to_cart_button');
            if (!atcDestination) return;

            if (atcSource) {
              atcDestination.innerHTML = atcSource.innerHTML;
            } else if (formId === `product-form-sticky-${this.sectionId}`) {
              this._updateStickyButtonPrice(variant);
            }

            atcDestination.dataset.available = variant.available ? 'true' : 'false';

            if (variant.available) {
              atcDestination.removeAttribute('disabled');
            } else {
              atcDestination.setAttribute('disabled', 'disabled');
            }
          });

        const stickyPriceSrc =
          this._queryInDoc(html, `#price-sticky-${this.sectionId}`) ||
          this._queryInDoc(html, `.price-sticky-${this.sectionId}`);
        if (stickyPriceSrc) {
          document.querySelectorAll(`.price-sticky-${this.sectionId}`).forEach((dest) => {
            dest.innerHTML = stickyPriceSrc.innerHTML;
          });
        }

        this._enableAtcButton(variant);
        this._updateProductForms(variant.id);

        const paymentDest = document.getElementById(`x-payment-button-${this.sectionId}`);
        const paymentSrc = html.getElementById(`x-payment-button-${this.sectionId}`);
        if (paymentSrc && paymentDest) {
          paymentDest.classList.toggle('hidden', paymentSrc.classList.contains('hidden'));
        }

        this._updateVariantMetafieldBlocks(html);
        this._publishStickyLbPrices();

        // Keep claw selector Alpine state; refresh media gallery from sibling section when present.
        const mediaDest = this._mediaRoot(document);
        const mediaSrc = this._mediaRoot(html);
        if (mediaDest && mediaSrc) {
          const splideEl = document.getElementById(`x-product-${this.sectionId}`);
          if (splideEl?.splide) {
            try {
              splideEl.splide.destroy();
            } catch (error) {
              // Splide may already be detached.
            }
          }
          mediaDest.innerHTML = mediaSrc.innerHTML;
          if (window.Alpine?.initTree) Alpine.initTree(mediaDest);
          this._goToVariantMedia(variant);
        }

        document.dispatchEvent(
          new CustomEvent('eurus:variant:change', {
            detail: { variant: variant.raw || variant },
          })
        );
        document.dispatchEvent(
          new CustomEvent(`eurus:product-page-variant-select:updated:${this.sectionId}`, {
            detail: { html },
          })
        );

        Alpine.store('xUpdateVariantQuanity')?.render?.(html, this.sectionId);
        Alpine.store('xPickupAvailable')?.updatePickUp?.(this.sectionId, variant.id);
      },
    }));
  };

  const boot = () => {
    if (window.Eurus?.loadedScript) {
      if (!window.Eurus.loadedScript.has('interactive-claw-selector.js')) {
        window.Eurus.loadedScript.add('interactive-claw-selector.js');
      }
    }
    registerInteractiveClawSelector();
    requestAnimationFrame(() => {
      if (!window.Alpine?.initTree) return;
      document.querySelectorAll('.interactive-claw-selector').forEach((el) => {
        if (!el._x_dataStack?.length) Alpine.initTree(el);
      });
    });
  };

  document.addEventListener('alpine:init', boot);

  document.addEventListener('shopify:section:load', (event) => {
    boot();
    if (!window.Alpine?.initTree) return;
    const root = event.target.querySelector('.interactive-claw-selector');
    if (root && !root._x_dataStack?.length) Alpine.initTree(root);
  });

  document.addEventListener('DOMContentLoaded', boot);
  if (window.Alpine) boot();
})();
